import CountAmenityGroup from "@CheckOrder/features/amenities/features/countAmenity/components/CountAmenityGroup";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import getPairedAmenityGroupType from "@CheckOrder/features/amenities/functions/getPairedAmenityGroupType";

interface AmenityGroupProps {
    pairedAmenityGroups: PairedSingleAndReturnAmenitiesType
    openErrorModal: () => void
    groupKey: string,
}

/**
 * A group of amenities, usually connected to the same type of service (e.g. food service)
 */
function AmenityGroup({pairedAmenityGroups, openErrorModal, groupKey}: AmenityGroupProps) {
    const type = getPairedAmenityGroupType(pairedAmenityGroups)

    if (type === "count") {
        return (
            <CountAmenityGroup
                pairedAmenityGroups={pairedAmenityGroups}
                openErrorModal={openErrorModal}
                groupKey={groupKey}
            />
        )
    }
}

export default AmenityGroup